import {createResponseList} from '../utils';

import {BasicTeamSerializedType, TeamSerializedType} from 'sweet-types';

let currentId = 0;

export const createFakeTeam = (name: string): TeamSerializedType => ({
  id: ++currentId,
  url: `/api/v2/teams/${currentId}/`,
  content_type: 'team',
  hashid: `team-${currentId}`,
  html_url: `/people/team/${currentId}/accounting/users/`,
  name,
  modified_at: '2023-03-14T11:07:32.571948Z',
  created_at: '2023-01-16T10:14:39.603488Z',
  slug: `team-${currentId}`,
  number_of_folders: 0,
  number_of_processes: 0,
  number_of_procedures: 0,
  number_of_policies: 0,
  number_of_roles: 0,
  num_managers: 0,
  num_readers: 0,
  teammates_can_assign_task: false,
  account_wide: false,
  can_edit: true,
  can_change: true,
  can_create: true,
  description: '',
  num_teammates: 0,
  signofftemplate: null,
});

export const teams_list_fixture = createResponseList([
  createFakeTeam('Accounting'),
  createFakeTeam('Marketing'),
  createFakeTeam('Customer Support'),
]);

export const getTeamByHashid = (hashid: string) => {
  const team = teams_list_fixture.results.filter(
    (team) => team.hashid === hashid
  );

  if (team.length === 0) {
    return createFakeTeam(hashid);
  }

  return team[0];
};

export const getTeamByURL = (url: string) => {
  const team = teams_list_fixture.results.filter((team) => team.url === url);

  if (team.length === 0) {
    return createFakeTeam(url);
  }

  return team[0];
};

export const generateBasicTeamFromTeam = (
  team: TeamSerializedType
): BasicTeamSerializedType => {
  return {
    url: team.url,
    id: team.id,
    name: team.name,
    content_type: 'team',
    html_url: team.html_url,
    hashid: team.hashid,
  };
};

export const generateFolderTeamMembershipFromTeam = (
  team: TeamSerializedType
) => {
  return {
    direct: true,
    team: team.url,
    url: 'test?',
  };
};
